if (!customElements.get('dg-help-center')) {
  customElements.define('dg-help-center', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.queryInput = this.querySelector('[data-faq-search]');
      this.items = [...this.querySelectorAll('[data-faq-item]')];
      this.filters = [...this.querySelectorAll('[data-faq-category]')];
      this.result = this.querySelector('[data-faq-results]');
      this.empty = this.querySelector('[data-faq-empty]');
      this.category = 'all';
      this.normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      this.queryInput?.addEventListener('input', () => this.filter());
      this.querySelector('[data-faq-search-form]')?.addEventListener('submit', event => { event.preventDefault(); this.filter(); });
      this.filters.forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.faqCategory;
        this.filter();
      }));
      this.querySelector('[data-faq-reset]')?.addEventListener('click', () => {
        this.category = 'all';
        if (this.queryInput) this.queryInput.value = '';
        this.filter();
        this.queryInput?.focus();
      });
      this.filter();
    }
    filter() {
      const words = this.normalize(this.queryInput?.value.trim() || '').split(/\s+/).filter(Boolean);
      let count = 0;
      this.items.forEach(item => {
        const matchesCategory = this.category === 'all' || item.dataset.category === this.category;
        const text = this.normalize(item.textContent);
        const visible = matchesCategory && words.every(word => text.includes(word));
        item.hidden = !visible;
        if (visible) count += 1;
      });
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqCategory === this.category)));
      if (this.empty) this.empty.hidden = count > 0;
      if (this.result) {
        const message = count === 1 ? this.dataset.resultOne : this.dataset.resultOther;
        this.result.textContent = (message || '').replace('[count]', String(count));
      }
    }
  });
}
